import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Chip,
  Divider,
  IconButton,
  Drawer,
  Button, CircularProgress
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../../AuthProvider";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";



const baseUrl = process.env.REACT_APP_API_BASE_URL;

const StudentAttendanceCalendar = () => {
  const navigate = useNavigate();
  const { studentId,romanNumberClass } = useParams();
  const { oId, pId } = useAuth();
  const studentName = sessionStorage.getItem("selectedStudentName");
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [attendanceData, setAttendanceData] = useState([]);
  const [attendanceCount, setAttendanceCount] = useState({ present: 0, absent: 0 });
  const [attendanceDates, setAttendanceDates] = useState([]);
  const [holidaysDates, setHolidaysDates] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loadingPresent, setLoadingPresent] = useState(false);
  const [loadingAbsent, setLoadingAbsent] = useState(false);

  







  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear - 1, currentYear];

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Fetch attendance summary counts
  const fetchAttendanceCounts = async () => {
    if (!studentId) return;
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/count-by-month-year-students/${studentId}/${year}/${month + 1}`
      );
      const data = await response.json();
      setAttendanceCount(data);
    } catch (error) {
      console.error("Error fetching attendance count:", error);
    }
  };

  // Fetch monthly attendance dates
  const fetchMonthlyAttendance = async () => {
    if (!studentId) return;
    try {
      const response = await fetch(
        `${baseUrl}/api/attendance/students/monthly/${studentId}/${year}/${month + 1}`
      );
      const data = await response.json();

      // Extract and normalize present dates
      const presentDates = data.map((record) =>
        new Date(record.date).toLocaleDateString("en-CA")
      );
      setAttendanceDates(presentDates);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    }
  };

  // Fetch attendance summary counts
  const fetchMonthlyHolidays = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/holiday/getHolidaysOn/${year}/${month + 1}/${pId}`
      );
      const data = await response.json();
      // Normalize dates to "YYYY-MM-DD"
      const formatted = data.map((h) => ({
        date: new Date(h.holidayDate).toLocaleDateString("en-CA"),
        name: h.holidayName,
      }));
      setHolidaysDates(formatted);
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };

  useEffect(() => {
    fetchMonthlyAttendance();
    fetchAttendanceCounts();
    fetchMonthlyHolidays();
  }, [month, year]);




  // Build calendar grid based on attendance data
  //   useEffect(() => {
  //     const daysInMonth = new Date(year, month + 1, 0).getDate();
  //     const newData = [];

  //     const firstDay = new Date(year, month, 1).getDay(); // 0=Sun
  //     const startOffset = firstDay === 0 ? 6 : firstDay - 1; // make Monday start

  //     // empty slots before first day
  //     for (let i = 0; i < startOffset; i++) {
  //       newData.push({ day: null, status: "Empty" });
  //     }

  //     const today = new Date();

  // for (let i = 1; i <= daysInMonth; i++) {
  //   const currentDate = new Date(year, month, i);
  //   const isoDate = currentDate.toLocaleDateString("en-CA");
  //   const dayOfWeek = currentDate.getDay();

  //   // 🚫 Future date check
  //   const isFuture =
  //     currentDate > today &&
  //     (currentDate.getMonth() !== today.getMonth() ||
  //       currentDate.getDate() > today.getDate() ||
  //       currentDate.getFullYear() > today.getFullYear());

  //   if (isFuture) {
  //     newData.push({ day: i, status: "Future" }); // disable future days
  //   } else if (dayOfWeek === 0) {
  //     newData.push({ day: i, status: "Sunday" });
  //   } else if (attendanceDates.includes(isoDate)) {
  //     newData.push({ day: i, status: "Present" });
  //   } else {
  //     newData.push({ day: i, status: "Absent" });
  //   }
  // }


  //     setAttendanceData(newData);
  //   }, [attendanceDates, month, year]);
  useEffect(() => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const newData = [];
    const firstDay = new Date(year, month, 1).getDay();
    const startOffset = firstDay === 0 ? 6 : firstDay - 1;
    const today = new Date();

    for (let i = 0; i < startOffset; i++) {
      newData.push({ day: null, status: "Empty" });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const currentDate = new Date(year, month, i);
      const isoDate = currentDate.toLocaleDateString("en-CA");
      const dayOfWeek = currentDate.getDay();

      const isFuture =
        currentDate > today &&
        (currentDate.getMonth() !== today.getMonth() ||
          currentDate.getDate() > today.getDate() ||
          currentDate.getFullYear() > today.getFullYear());

      const holiday = holidaysDates.find((h) => h.date === isoDate);

      if (isFuture) {
        newData.push({ day: i, status: "Future" });
      } else if (holiday) {
        newData.push({ day: i, status: holiday.name, type: "Holiday" });
      } else if (dayOfWeek === 0) {
        newData.push({ day: i, status: "Sunday" });
      } else if (attendanceDates.includes(isoDate)) {
        newData.push({ day: i, status: "Present" });
      } else {
        newData.push({ day: i, status: "Absent" });
      }
    }

    setAttendanceData(newData);
  }, [attendanceDates, holidaysDates, month, year]);



  // const handleDateClick = (item) => {
  //   if (item.status === "Empty" || item.status === "Sunday" || item.status === "Future") return;
  //   setSelectedDate(item);
  //   setDrawerOpen(true);
  // };
  const handleDateClick = (item) => {
    if (
      item.status === "Empty" ||
      item.status === "Sunday" ||
      item.status === "Future" ||
      item.type === "Holiday"
    )
      return;
    setSelectedDate(item);
    setDrawerOpen(true);
  };




  const handleMarkPresent = async () => {
    setLoadingPresent(true);
    try {
      // Construct URL with path variables
      const url = `${baseUrl}/api/attendance/present/student/${studentId}/${year}/${month + 1}/${selectedDate?.day}/${oId}`;

      const response = await fetch(url, {
        method: "POST",
        // headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to mark present");

      toast.success("Marked as Present!", { autoClose: 1000 });
      fetchMonthlyAttendance();
      fetchAttendanceCounts();
      setDrawerOpen(false)
    } catch (error) {
      console.error(error);
      toast.error("Failed to mark present", { autoClose: 2000 });
    } finally {
      setLoadingPresent(false);
    }
  };



const handleMarkAbsent = async () => {
  if (!romanNumberClass) {
    toast.error("Class not found");
    return;
  }

  setLoadingAbsent(true);
  try {
    const url = `${baseUrl}/api/attendance/students/absent/${studentId}/${year}/${month + 1}/${selectedDate?.day}?romanNumberClass=${romanNumberClass}`;

    const response = await fetch(url, { method: "DELETE" });

    if (!response.ok) throw new Error("Failed");

    toast.success("Marked as Absent!", { autoClose: 1000 });
    fetchMonthlyAttendance();
    fetchAttendanceCounts();
    setDrawerOpen(false);
  } catch (error) {
    toast.error("Failed to mark absent");
  } finally {
    setLoadingAbsent(false);
  }
};




  return (
    <>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
          p: 3,
          margin: "5% 1%",
          background: "linear-gradient(to bottom right, #f7f9fc, #ffffff)",
        }}
      >

        {/* Header */}
      <Box>

  {/* 🔹 FIRST ROW — Heading + Dropdowns */}
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mb={1.5}
  >
    {/* Left Side — Back Button + Heading */}
    <Box display="flex" alignItems="center">
      <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
        <KeyboardBackspaceIcon fontSize="medium" />
      </IconButton>

      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        <span style={{ color: "#757575", fontSize: "18px" }}>
          {studentName ? studentName.trim() : ""}
        </span>
        {" - Monthly Attendance"}
      </Typography>
    </Box>

    {/* Right Side — Month & Year Dropdowns */}
    <Box display="flex" gap={2}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select value={month} onChange={(e) => setMonth(e.target.value)}>
          {months.map((m, i) => (
            <MenuItem key={i} value={i}>
              {m}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 90 }}>
        <Select value={year} onChange={(e) => setYear(e.target.value)}>
          {yearOptions.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  </Box>

  {/* 🔹 SECOND ROW — NOTE CARD */}
  <Box
    sx={{
      mt: 1,
      p: 1.5,
      bgcolor: "#fff4e5",
      borderLeft: "4px solid #ff9800",
      borderRadius: "6px",
      display: "flex",
      alignItems: "flex-start",
      gap: 1.2,
      maxWidth: "100%",
      mb:1
    }}
  >
    <WarningAmberIcon sx={{ color: "#ff9800", mt: "2px" }} />

<Typography
  variant="body2"
  sx={{
    color: "#5d4636",
    fontSize: "0.9rem",
    lineHeight: 1.4,
    fontWeight: 500,
  }}
>
  1. After marking a student as <strong>Present</strong> or <strong>Absent</strong>, the attendance 
     will update within <strong>1 minute</strong>. Please wait for the update to complete and avoid 
     taking any further action during this time. <br /><br />
  2. In the monthly attendance calendar, today’s attendance will not be displayed immediately. 
     Only previous days’ attendance will be shown.
</Typography>



  </Box>

</Box>


        {/* Summary */}
        <Box
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          mb={2}
          p={1.5}
          borderRadius={2}
          sx={{
            background: "linear-gradient(90deg, #e8f5e9 0%, #f1f8e9 100%)",
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
          }}
        >
          <Typography variant="body1" fontWeight="bold" color="#0d47a1">
            Total Days: {attendanceCount.total}
          </Typography>
          <Typography variant="body1" fontWeight="bold" color="#388e3c">
            Present: {attendanceCount.present}
          </Typography>
          <Typography variant="body1" fontWeight="bold" color="#d32f2f">
            Absent: {attendanceCount.absent}
          </Typography>
          <Typography variant="body1" fontWeight="bold" color="#0288d1">
            Holidays: {attendanceCount.holiday}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Calendar */}
        <CardContent
          sx={{
            mt: 1,
            border: "2px solid #b3e5fc",
            borderRadius: 3,
            p: 1.5, // smaller padding
            backgroundColor: "#ffffff",
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
          }}
        >
          {/* Weekday Header */}
          <Grid container spacing={0}>
            {daysOfWeek.map((day) => (
              <Grid
                item
                xs={12 / 7}
                key={day}
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #90caf9",
                  py: 0.5, // smaller height
                  borderRadius: "4px 4px 0 0",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: "bold",
                    color: day === "Sun" ? "#d32f2f" : "#0d47a1",
                    letterSpacing: 0.3,
                    fontSize: "0.8rem", // smaller text
                  }}
                >
                  {day}
                </Typography>
              </Grid>
            ))}
          </Grid>

          {/* Calendar Cells */}
          <Grid container spacing={0}>
            {attendanceData.map((item, index) => (
              <Grid
                item
                xs={12 / 7}
                key={index}
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  border: "1px solid #e0e0e0",
                  minHeight: 70, // 👈 reduced from 90
                  // cursor:
                  //   item.status !== "Sunday" && item.status !== "Empty"
                  //     ? "pointer"
                  //     : "default",
                  cursor:
                    item.status !== "Sunday" &&
                      item.status !== "Empty" &&
                      item.status !== "Future" &&
                      item.type !== "Holiday"
                      ? "pointer"
                      : "default",
                }}
                onClick={() => handleDateClick(item)}
              >
                {item.day ? (
                  <Box
                    sx={{
                      width: "80%",
                      height: "75%",
                      borderRadius: 2,
                      textAlign: "center",
                      p: 0.6,
                      display: "flex", // 👈 add flex layout
                      flexDirection: "column", // 👈 stack date & status vertically
                      justifyContent: "center",
                      alignItems: "center",
                      // backgroundColor:
                      //   item.status === "Present"
                      //     ? "#c8e6c9"
                      //     : item.status === "Absent"
                      //     ? "#ffcdd2"
                      //     : item.status === "Sunday"
                      //     ? "#ffe0b2"
                      //     : "#eeeeee",
                      // boxShadow:
                      //   item.status === "Present"
                      //     ? "0 1px 4px rgba(76,175,80,0.25)"
                      //     : item.status === "Absent"
                      //     ? "0 1px 4px rgba(244,67,54,0.25)"
                      //     : item.status === "Sunday"
                      //     ? "0 1px 4px rgba(255,152,0,0.25)"
                      //     : "0 1px 3px rgba(158,158,158,0.15)",
                      backgroundColor:
                        item.type === "Holiday"
                          ? "#b3e5fc" // light blue for holidays
                          : item.status === "Present"
                            ? "#c8e6c9"
                            : item.status === "Absent"
                              ? "#ffcdd2"
                              : item.status === "Sunday"
                                ? "#ffe0b2"
                                : "#eeeeee",
                      boxShadow:
                        item.type === "Holiday"
                          ? "0 1px 4px rgba(33,150,243,0.25)"
                          : item.status === "Present"
                            ? "0 1px 4px rgba(76,175,80,0.25)"
                            : item.status === "Absent"
                              ? "0 1px 4px rgba(244,67,54,0.25)"
                              : item.status === "Sunday"
                                ? "0 1px 4px rgba(255,152,0,0.25)"
                                : "0 1px 3px rgba(158,158,158,0.15)",




                      transition: "transform 0.25s, box-shadow 0.25s",
                      // "&:hover": {
                      //   transform: item.status !== "Sunday" ? "scale(1.04)" : "none",
                      "&:hover": {
                        transform:
                          item.status !== "Sunday" && item.type !== "Holiday"
                            ? "scale(1.04)"
                            : "none",
                      },
                    }}
                  >
                    <Typography
                      variant="caption"
                      fontWeight="bold"
                      color="#2c3e50"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      {item.day}
                    </Typography>

                    {item.status !== "Future" && (
                      // <Chip
                      //   label={item.status}
                      //   size="small"
                      //   sx={{
                      //     mt: 0.5,
                      //     backgroundColor:
                      //       item.status === "Present"
                      //         ? "#4caf50"
                      //         : item.status === "Absent"
                      //         ? "#f44336"
                      //         : item.status === "Sunday"
                      //         ? "#fb8c00"
                      //         : "#9e9e9e",
                      //     color: "white",
                      //     fontWeight: "bold",
                      //     borderRadius: "5px",
                      //     fontSize: "0.65rem",
                      //     height: 18,
                      //   }}
                      // />
                      <Chip
                        label={item.status}
                        size="small"
                        sx={{
                          mt: 0.5,
                          backgroundColor:
                            item.type === "Holiday"
                              ? "#0288d1"
                              : item.status === "Present"
                                ? "#4caf50"
                                : item.status === "Absent"
                                  ? "#f44336"
                                  : item.status === "Sunday"
                                    ? "#fb8c00"
                                    : "#9e9e9e",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "5px",
                          fontSize: "0.65rem",
                          height: 18,
                        }}
                      />

                    )}

                  </Box>

                ) : (
                  <Box sx={{ width: "80%", height: "75%" }} />
                )}
              </Grid>
            ))}
          </Grid>
        </CardContent>

      </Card>

      {/* Right Side Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: 320, p: 3, display: "flex", flexDirection: "column", gap: 2 },
        }}
      >
        {/* --- Header with Title + Close Icon --- */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" fontWeight="bold">
            Mark Attendance
          </Typography>
          <IconButton
            size="small"
            onClick={() => setDrawerOpen(false)}
            sx={{
              color: "#000",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* --- Subtitle Below Title --- */}
        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            fontWeight: 500,
            fontSize: "1.05rem",
            color: "#333",
          }}
        >
          Attendance for{" "}
          <Box
            component="span"
            sx={{
              fontWeight: "bold",
              color: "#1976d2", // primary color highlight
              fontSize: "1.2rem",
              // background: "linear-gradient(90deg, #e3f2fd, #bbdefb)",
              px: 1,
              py: 0.3,
              borderRadius: 1,
            }}
          >
            {selectedDate?.day} {months[month]} {year}
          </Box>
        </Typography>


        {/* --- Buttons --- */}
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ py: 1.5, fontWeight: "bold" }}
          onClick={handleMarkPresent}
          disabled={loadingPresent}
        >
          {loadingPresent ? <CircularProgress size={24} color="inherit" /> : "Mark as Present"}
        </Button>

        <Button
          variant="contained"
          color="error"
          fullWidth
          sx={{ py: 1.5, fontWeight: "bold" }}
          onClick={handleMarkAbsent}
          disabled={loadingAbsent}
        >
          {loadingAbsent ? <CircularProgress size={24} color="inherit" /> : "Mark as Absent"}
        </Button>
      </Drawer>

      {/* Toast container */}
      <ToastContainer position="top-right" />
    </>
  );
};

export default StudentAttendanceCalendar;




